// tslint:disable
export enum AccountRoleType {
    // UNKN
    Unknown = 0,
    // PAT
    Patient = 1,
    // PSRB
    Prescriber = 2,
    // INS
    InsuranceProvider = 3,
    // PBM
    PharmacyBenefitManager = 4,
    // SEC
    SecondaryContact = 5,
    // MFT
    Manufacturer = 6,
    // EMP
    EMP = 7,
    // CSR
    CustomerServiceRep = 8,
    // PSRBSITE
    PrescriberSite = 9,
    // BRAND
    Brand = 10,
    // CHLD
    Child = 11,
    // SCWRK
    SocialWorker = 12,
    // FINREP
    FinancialRepresentative = 13,
    // LGLREP
    LegalRepresentative = 14,
    // COR
    Corporate = 15,
    // PERCNT
    PersonalContact = 16,
    // SPOUSE
    Spouse = 17,
    // PARENT
    Parent = 18,
    // HMHEALTH
    HomeHealth = 19,
    // ALTCNT
    AlternateContact = 20,
    // AUTOINJ
    AutoInjuryPlan = 21,
    // COMMPL
    CommercialPlan = 22,
    // FEDPL
    FederalEmployeeProgram = 23,
    // MEDAD
    Medicaid = 24,
    // MDCRAD
    MedicareAdvantage = 25,
    // MDCRB
    MedicareB = 26,
    // MDCRD
    MedicareD = 27,
    // MDGP
    MediGap = 28,
    // VATC
    VADoDTRICARE = 29,
    // WRKCMP
    WorkersCompensation = 30,
    // PLAN
    Plan = 31,
    // PAYER
    Payer = 32,
    // DMEP
    DurableMedicalEquiqmentPlan = 33,
    // MCMP
    ManagedCareMedicaidPlan = 34,
    // SPAP
    StatePharmacyAssistanceProgram = 35,
    // MEDAB
    MedicarePartABPlan = 36,
    // ADAP
    AidsDrugAssistanceProgram = 37,
    // STPL
    StatePlan = 38,
    // PRVD
    Provider = 39,
    // EPO
    ExclusiveProviderOrganization = 40,
    // INDEM
    IndemnityInsurance = 41,
    // HMO
    HealthMaintenanceOrganization = 42,
    // POSP
    PointOfServicePlan = 43,
    // PPO
    PreferredProviderOrganization = 44,
    // SELF
    Self = 45,
    // OFFCNT
    OfficeContact = 46,
    // PHARM
    Pharmacy = 47,
    // MDCRA
    MedicareA = 48,
    // HOSP
    Hospital = 49,
    // HOSPOP
    HospitalOutpatient = 50,
    // INFCTR
    InfusionCenter = 51,
    // RETPHAR
    RetailPharmacy = 52,
    // Foundation
    Foundation = 53,
    // SecSupp
    SecondarySupplemental = 54,
    // RegNurse
    RegisteredNurse = 55,
    // LicPractNurse
    LicensedPracticalNurse = 56,
    // CertNursingAsst
    CertifiedNursingAssistant = 57,
    // MedAsst
    MedicalAssistant = 58,
    // NatlHealthAgncy
    NationalHomeHealthAgency = 59,
    // IndlHealthAgncy
    IndependentHomeHealthAgency = 60,
    // Practice
    Practice = 61,
    // PDCI
    PerDiemContractIndividual = 62,
    // Employee
    Employee = 63,
}
(AccountRoleType as any)['UNKNOWN'] = 0;
(AccountRoleType as any)['PATIENT'] = 1;
(AccountRoleType as any)['PRESCRIBER'] = 2;
(AccountRoleType as any)['INSURANCEPROVIDER'] = 3;
(AccountRoleType as any)['PHARMACYBENEFITMANAGER'] = 4;
(AccountRoleType as any)['SECONDARYCONTACT'] = 5;
(AccountRoleType as any)['MANUFACTURER'] = 6;
(AccountRoleType as any)['CUSTOMERSERVICEREP'] = 8;
(AccountRoleType as any)['PRESCRIBERSITE'] = 9;
(AccountRoleType as any)['BRAND'] = 10;
(AccountRoleType as any)['CHILD'] = 11;
(AccountRoleType as any)['SOCIALWORKER'] = 12;
(AccountRoleType as any)['FINANCIALREPRESENTATIVE'] = 13;
(AccountRoleType as any)['LEGALREPRESENTATIVE'] = 14;
(AccountRoleType as any)['CORPORATE'] = 15;
(AccountRoleType as any)['PERSONALCONTACT'] = 16;
(AccountRoleType as any)['SPOUSE'] = 17;
(AccountRoleType as any)['PARENT'] = 18;
(AccountRoleType as any)['HOMEHEALTH'] = 19;
(AccountRoleType as any)['ALTERNATECONTACT'] = 20;
(AccountRoleType as any)['AUTOINJURYPLAN'] = 21;
(AccountRoleType as any)['COMMERCIALPLAN'] = 22;
(AccountRoleType as any)['FEDERALEMPLOYEEPROGRAM'] = 23;
(AccountRoleType as any)['MEDICAID'] = 24;
(AccountRoleType as any)['MEDICAREADVANTAGE'] = 25;
(AccountRoleType as any)['MEDICAREB'] = 26;
(AccountRoleType as any)['MEDICARED'] = 27;
(AccountRoleType as any)['MEDIGAP'] = 28;
(AccountRoleType as any)['VADODTRICARE'] = 29;
(AccountRoleType as any)['WORKERSCOMPENSATION'] = 30;
(AccountRoleType as any)['PLAN'] = 31;
(AccountRoleType as any)['PAYER'] = 32;
(AccountRoleType as any)['DURABLEMEDICALEQUIQMENTPLAN'] = 33;
(AccountRoleType as any)['MANAGEDCAREMEDICAIDPLAN'] = 34;
(AccountRoleType as any)['STATEPHARMACYASSISTANCEPROGRAM'] = 35;
(AccountRoleType as any)['MEDICAREPARTABPLAN'] = 36;
(AccountRoleType as any)['AIDSDRUGASSISTANCEPROGRAM'] = 37;
(AccountRoleType as any)['STATEPLAN'] = 38;
(AccountRoleType as any)['PROVIDER'] = 39;
(AccountRoleType as any)['EXCLUSIVEPROVIDERORGANIZATION'] = 40;
(AccountRoleType as any)['INDEMNITYINSURANCE'] = 41;
(AccountRoleType as any)['HEALTHMAINTENANCEORGANIZATION'] = 42;
(AccountRoleType as any)['POINTOFSERVICEPLAN'] = 43;
(AccountRoleType as any)['PREFERREDPROVIDERORGANIZATION'] = 44;
(AccountRoleType as any)['SELF'] = 45;
(AccountRoleType as any)['OFFICECONTACT'] = 46;
(AccountRoleType as any)['PHARMACY'] = 47;
(AccountRoleType as any)['MEDICAREA'] = 48;
(AccountRoleType as any)['HOSPITAL'] = 49;
(AccountRoleType as any)['HOSPITALOUTPATIENT'] = 50;
(AccountRoleType as any)['INFUSIONCENTER'] = 51;
(AccountRoleType as any)['RETAILPHARMACY'] = 52;
(AccountRoleType as any)['FOUNDATION'] = 53;
(AccountRoleType as any)['SECONDARYSUPPLEMENTAL'] = 54;
(AccountRoleType as any)['REGISTEREDNURSE'] = 55;
(AccountRoleType as any)['LICENSEDPRACTICALNURSE'] = 56;
(AccountRoleType as any)['CERTIFIEDNURSINGASSISTANT'] = 57;
(AccountRoleType as any)['MEDICALASSISTANT'] = 58;
(AccountRoleType as any)['NATIONALHOMEHEALTHAGENCY'] = 59;
(AccountRoleType as any)['INDEPENDENTHOMEHEALTHAGENCY'] = 60;
(AccountRoleType as any)['PRACTICE'] = 61;
(AccountRoleType as any)['PERDIEMCONTRACTINDIVIDUAL'] = 62;
(AccountRoleType as any)['EMPLOYEE'] = 63;
